export default "/arrow-down-double-fill.c0eb908fd36f103fc30fba1bbb184a0d.svg";